<template>
  <Breadcrumbs
      title="Order Request Schedule"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Order Request Schedule', path: '/order-request-schedule' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <schedule/>
    </div>
  </div>
</template>

<script>
import schedule from './posheduleForm.vue';

export default {
  name: 'indexList',
  components: {
    schedule,
  },
}
</script>